import { render } from "./LoyaltyProductCard.vue?vue&type=template&id=6212ddb4&scoped=true&ts=true"
import script from "./LoyaltyProductCard.vue?vue&type=script&lang=ts"
export * from "./LoyaltyProductCard.vue?vue&type=script&lang=ts"

import "./LoyaltyProductCard.vue?vue&type=style&index=0&id=6212ddb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6212ddb4"]])

export default __exports__